module.exports = __webpack_public_path__ + "img/eduardo.b00bff11.png";